/* eslint-disable max-len */
import filter from 'lodash/filter';
import { nonExistingNonRootZeroStates } from '@lyearn-team/content-processing-library';
import { user } from '../currentUser';
import getNonCreatedStatesForOffer from './getNonCreatedStatesForOffer';
import {
  getContentSettingsByContentList,
  getContentSettingsByContentListLocally,
  saveStatesNotInDataSync,
  getOfferByIdLocally,
  getMultipleOfferByIdLocally,
  getOfferByIdAndVersionIdRemotely,
  getMultipleOfferByIdAndVersionIdsRemotely,
  getStatesEnrolmentsStateInteractionsForOfferLocally,
  getStatesEnrolmentsStateInteractionsForOfferRemotely,
  fetchLatestOfferFromCloudfront
} from './DataService';

// const user = new User();

function attachContentSettingsToOffer(offer, contentSettings) {
  offer.contentSettings = contentSettings;
}

export async function fetchLearnerOfferLocally(offerId, userId) {
  try {
    const offer = await getOfferByIdLocally(offerId);
    if (!offer) throw new Error('OFFER_NOT_FOUND');

    const {
      states,
      enrolments,
      stateInteractions,
      contentSettings,
      contentDetails
    } = await getStatesEnrolmentsStateInteractionsForOfferLocally(offerId, userId);

    const nonCreatedStatesForOffer = getNonCreatedStatesForOffer(offer, states);
    if (nonCreatedStatesForOffer.length) {
      console.log('nonCreatedStatesForOffer - ids are', nonCreatedStatesForOffer);
      window.analytics &&
        window.analytics.track('NON_CREATED_STATES_FOR_OFFER_ERROR', {
          message: 'nonCreatedStatesForOffer',
          states: JSON.stringify(nonCreatedStatesForOffer),
          URL: window.location.href
        });
      throw new Error('nonCreatedStatesForOffer');
    }

    const offerEnrolment = enrolments.find(e => e && e.contentId === offerId);
    const curriculumIds =
      offerEnrolment && offerEnrolment.parentIds ? offerEnrolment.parentIds : [];
    const curriculumOffers = await getMultipleOfferByIdLocally(curriculumIds);

    let prerequisitesResponse = {};

    const offerContentSetting = contentSettings.find(c => c && c.contentId === offerId);
    if (
      offerContentSetting &&
      offerContentSetting.prerequisites &&
      offerContentSetting.prerequisites.length > 0
    ) {
      const response = await getContentSettingsByContentListLocally(
        contentSettings[0].prerequisites.map(pr => ({
          contentId: pr.offerId,
          contentType: 'offer'
        })),
        ['enrolments', 'states', 'contentSettings'],
        user.id()
      );

      prerequisitesResponse = response;
    }

    attachContentSettingsToOffer(offer, offerContentSetting);

    return {
      offer,
      states: filter(states),
      enrolments: filter(enrolments),
      stateInteractions: filter(stateInteractions),
      curriculumOffers: filter(curriculumOffers),
      contentSettings: filter(contentSettings),
      contentDetails,
      preRequisitesData: prerequisitesResponse
    };
  } catch (error) {
    console.log('Error in fetchOffer is', error);
    if (!userId) {
      console.log('userId is - fetchLearnerOfferLocally ', userId);
    }
    return null;
  }
}

export async function fetchLearnerOfferRemotely(offerId, userId, overwriteStates) {
  try {
    const companyId = user.companyId();
    if (!userId) throw new Error('Handle_Logout_No_UserId');
    const {
      states: fetchedStates,
      enrolments,
      stateInteractions,
      contentSettings,
      contentDetails
    } = await getStatesEnrolmentsStateInteractionsForOfferRemotely(
      offerId,
      userId,
      overwriteStates
    );

    const offerEnrolment = enrolments && enrolments.find(e => e.contentId === offerId);

    let offer = null;
    if (offerEnrolment) {
      offer = await getOfferByIdAndVersionIdRemotely(offerId, offerEnrolment.versionId);
    } else {
      offer = await fetchLatestOfferFromCloudfront(offerId);
    }

    const curriculumIds =
      offerEnrolment && offerEnrolment.parentIds ? offerEnrolment.parentIds : [];
    let curriculumOffers = [];
    const curriculumEnrolments = enrolments.filter(e => curriculumIds.includes(e.contentId));
    const curriculumIdVersionIds = curriculumEnrolments.map(e => ({
      versionId: e.versionId,
      offerId: e.contentId
    }));
    curriculumOffers = await getMultipleOfferByIdAndVersionIdsRemotely(curriculumIdVersionIds);
    // Create non-root states if enrolled
    let dummyNonRootStates = [];
    if (offerEnrolment) {
      // MS:todo add companyId check
      dummyNonRootStates = nonExistingNonRootZeroStates(
        offer,
        { userId, companyId },
        fetchedStates
      );
      await saveStatesNotInDataSync(dummyNonRootStates);
    }
    const states = [...fetchedStates, ...dummyNonRootStates];

    let prerequisitesResponse = {};

    if (contentSettings[0].prerequisites && contentSettings[0].prerequisites.length > 0) {
      const response = await getContentSettingsByContentList(
        contentSettings[0].prerequisites.map(pr => ({
          contentId: pr.offerId,
          contentType: 'offer'
        })),
        ['enrolments', 'states', 'contentSettings'],
        user.id()
      );

      prerequisitesResponse = response;
    }

    return {
      offer,
      states: filter(states),
      enrolments: filter(enrolments),
      stateInteractions: filter(stateInteractions),
      curriculumOffers: filter(curriculumOffers),
      contentSettings: filter(contentSettings),
      contentDetails,
      preRequisitesData: prerequisitesResponse
    };
  } catch (error) {
    if (!userId) {
      console.log('userId is - fetchLearnerOfferRemotely ', userId);
    }
    console.error('error:', error);
    window.bugsnagClient &&
      window.bugsnagClient.notify(error, {
        metaData: {
          cookies: document.cookie,
          userId: user.id(),
          time: new Date().toISOString()
        }
      });
    throw error;
  }
}

export default async function fetchOfferLocallyOrRemotely(offerId, userid) {
  const userId = userid || user.id();
  const localData = await fetchLearnerOfferLocally(offerId, userId);
  if (localData) return localData;

  return fetchLearnerOfferRemotely(offerId, userId);
}
